<template>
    <div class="u-page-wrapper pb-56">
        <div class="mb-16">
            <div class="u-page-headline u-flex u-flex--space-between u-flex--vertical-center">
                <h2 class="u-size-body">
                    <i class="el-icon-check" aria-hidden="true"></i>
                    Tankfüllungen
                </h2>

                <el-button type="text" icon="el-icon-plus" circle @click="showAddModal = true" />
            </div>

            <template v-if="items.length">
                <el-row
                    v-for="(item, i) in items"
                    :key="`tank-items-${i}`"
                    class="tank-item mb-24 u-size-14"
                    :gutter="12"
                >
                    <el-col :span="12" class="tire__headline">Datum:</el-col>
                    <el-col :span="12" class="tire__value">{{ $date(new Date(item.date), 'dd.MM.yyyy') }}</el-col>
                    <el-col :span="12" class="tire__headline">Kosten pro l:</el-col>
                    <el-col :span="12" class="tire__value">{{ item.costs ? `${item.costs} €` : 'N/A' }}</el-col>
                    <el-col :span="12" class="tire__headline">Summe:</el-col>
                    <el-col :span="12" class="tire__value">{{ `${item.sum} €` }}</el-col>
                </el-row>
            </template>
            <p v-else class="u-size-14 mt-16 text-primary">Du hast noch keine Tankfüllung hinzugefügt.</p>
        </div>

        <add-tank-modal
            v-model="showAddModal"
            @reload="loadItems"
        />
    </div>
</template>

<script>
import Appwrite from '@/assets/appwrite'
import AddTankModal from '@/components/modals/AddTankModal.vue'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'

export default {
    name: 'Tank',

    components: { AddTankModal },

    data: () => ({ items: [], showAddModal: false }),

    mounted () {
        this.loadItems()
    },

    methods: {
        async loadItems () {
            try {
                const { documents } = await Appwrite.databases.listDocuments(Appwrite.DB_NAME, 'tank', [
                    Appwrite.Query.orderDesc('date'),
                ])
                if (!documents.length) return []

                this.items = documents.map(x => ({ ...x, created: x.$createdAt, date: format(parseISO(x.date), 'yyyy-MM-dd') }))
            } catch (e) {
                this.$notify({
                    title: 'Error',
                    message: e.message,
                    type: 'error',
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.tank-item {
    padding-bottom: $spacing-unit-16;
    border-bottom: 1px solid rgba($white, 0.2);
}
</style>
